import React, { Component } from 'react'

import { API_BASE_URL_DEV, API_BASE_URL_PROD } from './../config.js'

export default class Landing extends Component {
  constructor(props) {
    super(props)
    this.state = { landings: [], index: 0 }
  }

  componentDidMount() {
    const url =
      (process.env.NODE_ENV === 'development'
        ? API_BASE_URL_DEV
        : API_BASE_URL_PROD) + 'landings'

    fetch(url, {})
      .then(response => response.json())
      .then(json =>
        this.setState({
          index: Math.floor(Math.random() * json.length),
          landings: json
        })
      )
  }

  selectPhrase(event) {
    if (window.innerWidth > 590) {

    } else {
      if (event.clientX < (window.innerWidth / 2)) {
        this.lastPhrase()
      } else {
        this.nextPhrase()
      }
    }
  }

  lastPhrase() {
    this.setState({
      index:
        this.state.index === 0
          ? this.state.landings.length - 1
          : this.state.index - 1
    })
  }

  nextPhrase() {
    this.setState({
      index:
        this.state.index === this.state.landings.length - 1
          ? 0
          : this.state.index + 1
    })
  }

  render() {
    if (this.state.landings.length === 0) {
      return <div />
    }
    return (
      <div className="landing" onClick={this.selectPhrase.bind(this)}>
        <div
          className={
            'landing-text landing-text--' +
            this.state.landings[this.state.index].Size
          }
          dangerouslySetInnerHTML={{
            __html: this.state.landings[this.state.index].Content
          }}
        />
        <div
          className="landing-turnpage landing-turnpage--left"
          onClick={this.lastPhrase.bind(this)}
        >
          {'<'}
        </div>
        <div
          className="landing-turnpage landing-turnpage--right"
          onClick={this.nextPhrase.bind(this)}
        >
          {'>'}
        </div>
      </div>
      
    )
  }
}



// WEBPACK FOOTER //
// ./src/front/components/landing.js